import { defineMessages } from "react-intl";

const PREFIX = "TablePricesWidget";
export default defineMessages({
  headerLabelLeftTable: {
    id: `${PREFIX}.header.label.leftTable`,
    defaultMessage: "Latest weekly commodity prices and historical peaks:",
  },
  headerLabelRightTable: {
    id: `${PREFIX}.header.label.rightTable`,
    defaultMessage: "Latest Weekly Fertilizer Prices and Historical Peaks:",
  },
  datePostFix: {
    id: `${PREFIX}.table.date.postfix`,
    defaultMessage: "(US$ per MT)",
  },
  tableFooterSource: {
    id: `${PREFIX}.table.footer.source`,
    defaultMessage: "Source:",
  },
});
